// Curated topic suggestions surfaced on Image + Video studios so a
// first-time user can go from empty-state → publication-ready asset in
// two clicks (pick a topic → Generate).
//
// The buckets mirror the layout families DAAM's editorial system supports.
// Every suggestion is written to work equally well as an image caption
// prompt AND a cinematic video topic — the same string powers both studios.

export const TOPIC_CATEGORIES = [
  {
    key: "travel",
    labelAr: "سفر",
    labelEn: "Travel",
    icon: "MapPin",
    topics: [
      { ar: "أفضل الأماكن في شمال إيطاليا", en: "Best places in northern Italy" },
      { ar: "رحلة إلى بحيرات إنترلاكن السويسرية", en: "Interlaken lakes travel guide" },
      { ar: "5 مدن يجب زيارتها في المغرب", en: "5 cities to visit in Morocco" },
      { ar: "دليل الصيف في اليونان", en: "Summer guide to Greece" },
    ],
  },
  {
    key: "news",
    labelAr: "أخبار",
    labelEn: "News",
    icon: "Newspaper",
    topics: [
      { ar: "أهم قرارات قمة الاقتصاد الرقمي هذا الأسبوع", en: "This week in digital economy news" },
      { ar: "توقعات الطقس القصوى في الرياض", en: "Extreme weather outlook for Riyadh" },
    ],
  },
  {
    key: "business",
    labelAr: "أعمال",
    labelEn: "Business",
    icon: "Briefcase",
    topics: [
      { ar: "خمس عادات تميز رواد الأعمال الناجحين", en: "5 habits of successful founders" },
      { ar: "كيف تستثمر أول ١٠ آلاف ريال في ٢٠٢٦", en: "How to invest your first SAR 10k in 2026" },
      { ar: "دليل بناء علامة تجارية شخصية", en: "Personal branding playbook" },
    ],
  },
  {
    key: "food",
    labelAr: "طعام",
    labelEn: "Food",
    icon: "UtensilsCrossed",
    topics: [
      { ar: "أفضل مطاعم الرياض للعائلات", en: "Best family restaurants in Riyadh" },
      { ar: "طريقة تحضير الكبسة السعودية الأصيلة", en: "Authentic Saudi kabsa recipe" },
      { ar: "قهوة الصباح — 3 وصفات فاخرة", en: "Morning coffee — 3 luxurious recipes" },
    ],
  },
  {
    key: "quote",
    labelAr: "اقتباس",
    labelEn: "Quote",
    icon: "Quote",
    topics: [
      { ar: "اقتباس عن الصبر والنجاح", en: "A quote about patience and success" },
      { ar: "حكمة اليوم للقيادة الملهمة", en: "Today's quote on inspiring leadership" },
    ],
  },
  {
    key: "howto",
    labelAr: "تعليمي",
    labelEn: "Tutorial",
    icon: "GraduationCap",
    topics: [
      { ar: "خطوات إنشاء متجر إلكتروني ناجح", en: "Steps to build a successful online store" },
      { ar: "كيف تصمم منشوراً احترافياً على إنستقرام", en: "How to design a pro-looking Instagram post" },
    ],
  },
  {
    key: "stats",
    labelAr: "إحصائيات",
    labelEn: "Stats",
    icon: "BarChart3",
    topics: [
      { ar: "إحصائيات استخدام السوشيال ميديا في السعودية ٢٠٢٦", en: "Saudi social media stats 2026" },
      { ar: "أهم أرقام سوق التجارة الإلكترونية في الخليج", en: "GCC e-commerce market — key numbers" },
    ],
  },
  {
    key: "lifestyle",
    labelAr: "أسلوب حياة",
    labelEn: "Lifestyle",
    icon: "Heart",
    topics: [
      { ar: "روتين صباحي يغيّر يومك", en: "A morning routine that changes your day" },
      { ar: "دليل موضة الخريف ٢٠٢٦", en: "Fall 2026 fashion guide" },
      { ar: "أفكار تصميم داخلي لغرفة معيشة عصرية", en: "Modern living-room design ideas" },
    ],
  },
];

// Flatten to a shuffled pool for the "Surprise me" chip that surfaces one
// random topic across all categories.
export function randomTopic(lang = "ar") {
  const all = TOPIC_CATEGORIES.flatMap((c) => c.topics);
  const pick = all[Math.floor(Math.random() * all.length)];
  return lang === "ar" ? pick.ar : pick.en;
}
